import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { AddDVActivationComponent } from "./add-dvactivation/add-dvactivation.component";
import { EditDVActivationComponent } from "./edit-dvactivation/edit-dvactivation.component";
import { DataService_DriverVerifyActivation } from "./shared/data.service";
import { DomSanitizer } from "@angular/platform-browser";
import { DriverActivationPrintRequest } from "./shared/DriverActivationPrintRequest";
import { ConfirmationService } from "primeng/api";
import { EmailDVActivationComponent } from "./email-dvactivation/email-dvactivation.component";

@Component({
	selector: "app-driver-verify-activation",
	templateUrl: "./driver-verify-activation.component.html",
	styleUrls: ["./driver-verify-activation.component.css"],
})
export class DriverVerifyActivationComponent implements OnInit {
	constructor(
		private sanitizer: DomSanitizer,
		private userService: UserService,
		private DriverActivationService: DataService_DriverVerifyActivation,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadDriverVerifyActivation();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	Processing: any = false;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedDriverVerifyActivation: any;
	lstDriverVerifyActivation: any = [];

	//Filter lists
	lstActiveDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "AvailableCount", header: "Activations Left" },
		{ field: "TotalCount", header: "Total Issued" },
		{ field: "IssueDateDesc", header: "Issue Date" },
		{ field: "ExpireDateDesc", header: "Expire Date" },
		// { field: 'ActiveDesc', header: 'Active' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadDriverVerifyActivation() {
		this.loading = true;

		var result = this.DriverActivationService.DriverActivationSelectList();
		result.subscribe(
			(response) => {
				this.lstDriverVerifyActivation = response;

				for (var z = 0; z < this.lstDriverVerifyActivation.length; z++) {
					var next = this.lstDriverVerifyActivation[z];

					next.PhotoData = this.sanitizer.bypassSecurityTrustResourceUrl(next.QRCode);
				}

				//Load Data Filter Lists
				this.lstActiveDesc = Array.from(new Set(this.lstDriverVerifyActivation.map((item: any) => item.ActiveDesc)));

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadDriverVerifyActivation();
	}

	//Custom Button Methods
	onAdd() {
		this.errorMessage = "";

		var ref = this.dialogService.open(AddDVActivationComponent, {
			header: "Add Activation Code",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadDriverVerifyActivation();
			}
		});
	}

	onEdit() {
		this.errorMessage = "";

		if (this.SelectedDriverVerifyActivation == undefined) {
			this.errorMessage = "Select an activation code to edit";
			return;
		}

		var ref = this.dialogService.open(EditDVActivationComponent, {
			header: "Edit Activation Code",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				DriverVerifyActivationID: this.SelectedDriverVerifyActivation.DriverVerifyActivationID,
				ActivationCode: this.SelectedDriverVerifyActivation.ActivationCode,
				AvailableCount: this.SelectedDriverVerifyActivation.AvailableCount,
				TotalCount: this.SelectedDriverVerifyActivation.TotalCount,
				// IssueDate: this.SelectedDriverVerifyActivation.IssueDate,
				IssueDateDesc: this.SelectedDriverVerifyActivation.IssueDateDesc,
				ExpireDate: this.SelectedDriverVerifyActivation.ExpireDate,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadDriverVerifyActivation();
			}
		});
	}

	onPrint() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedDriverVerifyActivation == undefined) {
			this.errorMessage = "Select an activation code to print";
			return;
		}

		//Call SP
		this.Processing = true;

		//Create Request
		let parms: DriverActivationPrintRequest = {
			QRTextRaw: this.SelectedDriverVerifyActivation.QRTextRaw,
		};

		var result = this.DriverActivationService.DriverActivationPrint(parms);
		result.subscribe(
			(response) => {
				var a = document.createElement("a"); //Create <a>
				a.href = response[0];
				a.download = "QRCode_" + this.SelectedDriverVerifyActivation.ActivationCode;
				a.click(); //Downloaded file

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onEmail() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedDriverVerifyActivation == undefined) {
			this.errorMessage = "Select an activation code to email";
			return;
		}

		if (this.SelectedDriverVerifyActivation.Active == 0) {
			this.confirmationService.confirm({
				key: "main",
				acceptLabel: "Yes",
				rejectLabel: "No",
				rejectVisible: true,
				message:
					"Activation code is inactive and can't be used to register users unless the expiration date changes or more licenses are purchased. Are you sure you want to email it?",
				header: "Activation Code Inactive",
				icon: "fa",
				accept: () => {
					this.FinishOpenEmailDialog();
				},
				reject: () => {
					return;
				},
			});
		} else {
			this.FinishOpenEmailDialog();
		}
	}

	FinishOpenEmailDialog() {
		//Call SP
		var ref = this.dialogService.open(EmailDVActivationComponent, {
			header: "Email Activation Code",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				QRCode: this.SelectedDriverVerifyActivation.QRCode,
				// QRTextRaw: this.SelectedDriverVerifyActivation.QRTextRaw,
				ExpireDateDesc: String(this.SelectedDriverVerifyActivation.ExpireDateDesc),
				ActivationCode: this.SelectedDriverVerifyActivation.ActivationCode,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
			}
		});
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedDriverVerifyActivation = val.data;
	}
	onRowUnselect(val) {
		this.SelectedDriverVerifyActivation = null;
	}
	onRowDblClick(DriverVerifyActivation) {
		this.SelectedDriverVerifyActivation = DriverVerifyActivation;
		this.onEmail();
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	IsLoading() {
		return this.loading == true || this.Processing == true;
	}

	IsSU() {
		if (this.user == undefined) {
			return false;
		} else {
			return this.user.userID == 0;
		}
	}

	////////////////////////////////////////////
}
